import {
  currentActiveFileUpdated,
  selectContentLibraryActiveFiles,
} from 'features/content-library/contentLibrarySlice';
import { ContentLibraryOpenedFile } from 'features/content-library/types';
import {
  gridPanelOpened,
  gridPanelVoided,
  selectLockedFile,
} from 'features/layout/features/content/contentSlice';
import { pickLatestByDate } from 'features/content-library/utils/pickLatestByDate';
import { call, put, select } from 'redux-saga/effects';
import { fileViewed } from 'features/content-library/actions';
import { contentBoard } from 'features/content-whiteboard/utils/contentBoardStateManager';

export function* openLastActiveFileSaga(id?: string) {
  const currentFiles: ContentLibraryOpenedFile[] = yield select(selectContentLibraryActiveFiles);

  const files = currentFiles.filter((item) => item.id !== id);

  if (files.length === 0) {
    yield put(gridPanelVoided('contentLibrary'));

    if (contentBoard.id && contentBoard.type === 'file') {
      yield call(contentBoard.reset);
    }
  }

  if (files.length > 0) {
    const lockedFile: ContentLibraryOpenedFile | undefined = yield select(selectLockedFile);

    const targetFile = lockedFile ?? pickLatestByDate(files);

    yield put(fileViewed({ id: targetFile.id }));
    yield put(currentActiveFileUpdated(targetFile.id));
    yield put(gridPanelOpened('contentLibrary'));
  }
}
